import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["type", "children", "anchorComponent", "dashed", "bold", "inherit", "openInNewWindow"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import StyledLink from './styles';
import eventCode from '../utils/event-code';
var linkAsButton = function linkAsButton(_ref) {
  var href = _ref.href,
    onClick = _ref.onClick,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'button' : _ref$role,
    _ref$tabIndex = _ref.tabIndex,
    tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
    originalKeyPress = _ref.onKeyPress;
  if (href) return {};
  var onKeyPress = function onKeyPress(event) {
    var code = eventCode(event);
    if (originalKeyPress) {
      originalKeyPress(event);
    }
    if ((code === 'Enter' || code === 'Space') && onClick) {
      onClick(event);
    }
  };
  return _objectSpread({
    role: role,
    tabIndex: tabIndex,
    onKeyPress: onKeyPress
  }, onClick ? {
    onClick: onClick
  } : {});
};
var Link = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var type = _ref2.type,
    children = _ref2.children,
    anchorComponent = _ref2.anchorComponent,
    dashed = _ref2.dashed,
    bold = _ref2.bold,
    inherit = _ref2.inherit,
    openInNewWindow = _ref2.openInNewWindow,
    props = _objectWithoutProperties(_ref2, _excluded);
  var openInNewWindowProps = openInNewWindow ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {};
  return /*#__PURE__*/React.createElement(StyledLink, _extends({
    "data-type": type,
    "data-dashed": dashed,
    $bold: bold,
    "data-inherit": inherit,
    as: anchorComponent
  }, _objectSpread(_objectSpread(_objectSpread({
    ref: ref
  }, openInNewWindowProps), props), linkAsButton(props))), children);
});
Link.propTypes = {
  anchorComponent: PropTypes.elementType,
  children: PropTypes.node,
  dashed: PropTypes.bool,
  bold: PropTypes.bool,
  inherit: PropTypes.bool,
  openInNewWindow: PropTypes.bool,
  type: PropTypes.oneOf(['default', 'unstyled', 'text', 'no-underline'])
};
Link.defaultProps = {
  anchorComponent: null,
  dashed: false,
  bold: false,
  inherit: false,
  children: undefined,
  openInNewWindow: false,
  type: 'default'
};
export default Link;
export { linkAsButton };
//# sourceMappingURL=index.js.map